const factories = [
  () => import('@/pages/Landing'),
  () => import('@/pages/Dashboard'),
  () => import('@/pages/Screen'),
  () => import('@/pages/analysis/AnalysisShell'),
  () => import('@/pages/analysis/OverviewTab'),
  () => import('@/pages/analysis/FinancialsTab'),
  () => import('@/pages/analysis/ValuationTab'),
  () => import('@/pages/analysis/CompsTab'),
  () => import('@/pages/analysis/QualitativeTab'),
  () => import('@/pages/analysis/RiskTab'),
  () => import('@/pages/analysis/FilingsTab'),
  () => import('@/pages/MoatDetail'),
  () => import('@/pages/JobProgress'),
  () => import('@/pages/Compare'),
  () => import('@/pages/ManualInput'),
  () => import('@/pages/MNA'),
  () => import('@/pages/MNAResults'),
  () => import('@/pages/Analytics'),
  () => import('@/pages/Watchlist'),
  () => import('@/pages/Events'),
  () => import('@/pages/Portfolio'),
  () => import('@/pages/Estimates'),
  () => import('@/pages/Compliance'),
  () => import('@/pages/DevTools'),
  () => import('@/pages/Backtesting'),
  () => import('@/pages/BatchAnalysis'),
  () => import('@/pages/FactorAnalytics'),
  () => import('@/pages/MLInsights'),
  () => import('@/pages/Strategies'),
  () => import('@/pages/apophis/Apophis'),
  () => import('@/pages/apophis/ApophisRequest'),
  () => import('@/pages/apophis/ApophisDelivery'),
  () => import('@/pages/apophis/ApophisHistory'),
  () => import('@/pages/apophis/ApophisCatalog'),
  () => import('@/pages/apophis/ApophisGenerate'),
  () => import('@/pages/apophis/ApophisJob'),
  () => import('@/pages/apophis/ApophisDocuments'),
  () => import('@/pages/dashboard/QuantitativePage'),
  () => import('@/pages/dashboard/CreditRiskPage'),
  () => import('@/pages/dashboard/InsiderFlowPage'),
  () => import('@/pages/dashboard/GovernancePage'),
  () => import('@/pages/dashboard/EventTimelinePage'),
  () => import('@/pages/dashboard/OptionsMarketPage'),
  () => import('@/pages/dashboard/MacroOverlayPage'),
  () => import('@/pages/dashboard/AttentionSentimentPage'),
  () => import('@/pages/Moat'),
  () => import('@/pages/Calibration'),
  () => import('@/pages/CreditUniverse'),
  () => import('@/pages/CrowdedTrades'),
  () => import('@/pages/Login'),
  () => import('@/pages/Register'),
  () => import('@/pages/ForgotPassword'),
  () => import('@/pages/ResetPassword'),
  () => import('@/pages/VerifyEmail'),
  () => import('@/pages/Profile'),
  () => import('@/pages/NotFound'),
  () => import('@/pages/Settings'),
  () => import('@/pages/_devtools/DesignSystemPreview'),
  () => import('@/terminal/Terminal'),
  () => import('@/pages/ContrarianSignals'),
  () => import('@/pages/ThematicResearch'),
  () => import('@/pages/PodcastIntelligence'),
  () => import('@/pages/SectorSkills'),
  () => import('@/pages/ResearchInbox'),
  () => import('@/pages/PeerGroups'),
  () => import('@/pages/DataPipelines'),
]

export function preloadAllRoutes() {
  const load = () => {
    for (const f of factories) f().catch(() => {})
  }
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load)
  } else {
    setTimeout(load, 200)
  }
}
